import React, { useEffect, useState } from 'react';
import { LiveAudioVisualizer } from 'react-audio-visualize';
import FileUpload from './chatFileUpload';
import VoiceAssistant from './voiceAssistant';
import { MSG_SEND, EMOJI_ICON, DictateMICK, ClOSE, Right_Icon, ANIMATED_LOADER } from '../../common/images-svg';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../MUIS/loader';

const ChatToolbar = ({
  input,
  setInput,
  onSendMessage,
  isSending,
  isLoading,
  recordingStatus,
  mediaRecorder,
  inputRef,
  handleStartListening,
  handleStopListening,
  handleDiscard,
  showEmojiPicker,
  setShowEmojiPicker,
  fileUpload,
  isRemoveFile,
  setAttachmentError,
  attachmentError,
  showFile,
  resetFileObject,
  updateMessage,
  onClosePopup,
  showVoiceAssistant = true,
  showDictate = true,
  onZakatData,
}) => {
  const [isMediaRecorder, setIsMediaRecorder] = useState(null);
  const isVoiceAssistantOpen = useSelector((state) => state.aiChatbotSlice.isVoiceAssistantOpen);
  const isMicOn = useSelector((state) => state.aiChatbotSlice.isMicOn);
  const user = useSelector((state) => state.userReducer);

  const isDisabled = isSending || isLoading;

  useEffect(() => {
    setIsMediaRecorder(mediaRecorder);
    console.log('ChatToolbar: isMediaRecorder:', mediaRecorder, 'recordingStatus:', recordingStatus, 'isVoiceAssistantOpen:', isVoiceAssistantOpen);
    if (!mediaRecorder) {
      console.warn('ChatToolbar: MediaRecorder is null');
    }
  }, [mediaRecorder]);

  const handleMediaRecorderChange = (mediaRecorder) => {
    console.log('ChatToolbar: handleMediaRecorderChange:', mediaRecorder);
    if (!mediaRecorder) {
      console.warn('ChatToolbar: MediaRecorder is null');
      setIsMediaRecorder(null);
      return;
    }
    setIsMediaRecorder(mediaRecorder);
  };

  // console.log('ChatToolbar Render:', { isVoiceAssistantOpen, recordingStatus, isMediaRecorder });
  const handleInput = () => {
      const textarea = inputRef.current;
      if (textarea) {
          textarea.style.height = 'auto'; // Reset first
          textarea.style.height = `${Math.min(textarea.scrollHeight, 79)}px`;
          console.log("textarea.style.height", textarea.style.height)
          const root = document.documentElement;
          root?.style.setProperty("--inputHeightAdded", textarea.style.height ? textarea.style.height : "40px");
        }
  };
  return (
    <>
      {isLoading ? (
        <div className="enroll-confirm-loaders site-loaders chat-loader">
          <Loader />
        </div>
      ) : (
        <div
          className={`chatBot-toolbar ${
            isVoiceAssistantOpen
              ? 'showVoiceAssistant'
              : recordingStatus !== 'idle' && isMediaRecorder
              ? 'yeslistening'
              : ''
          }`}
        >
          <div className="chatBot-input">
            <textarea
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Ask anything"
              className={`chatBot-inputBox`} //${isDisabled ? 'disabled' : ''}
              onInput={handleInput}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey && !isDisabled) {
                  e.preventDefault();
                  onSendMessage(input);
                  setInput('');
                  setTimeout(() => handleInput(), 0); // Defer to ensure DOM updates
                }
            }}
              // disabled={isDisabled}
              ref={inputRef}
            />
          </div>
          <div className="chat-controls">
            <div className="chat-options">
              {user?.isBusinessPayer ? (
                <div className="chatBot-fileUpload">
                  <FileUpload
                    style="chatBot"
                    setFIleDetails={fileUpload}
                    isRemoveFile={isRemoveFile}
                    setAttachmentError={setAttachmentError}
                    hasError={attachmentError}
                    iconOnly={true}
                    resetFileObject={resetFileObject}
                    isShowfile={showFile}
                    disabled={isDisabled}
                  />
                </div>
              ) : null}
            </div>
            <div className="chat-option">
              <div>
                {showDictate && (
                  <div className="audio-controls">
                    {recordingStatus === 'idle' ||
                    (!isVoiceAssistantOpen && !isMediaRecorder) ? (
                      <button
                        onClick={handleStartListening}
                        className={`btn-start-audio blank-btn ${
                          isDisabled ? 'cursor-not-allowed' : ''
                        }`}
                        disabled={isDisabled || isVoiceAssistantOpen}
                      >
                        {DictateMICK}
                      </button>
                    ) : (
                      <div className="controls-active">
                        {recordingStatus === 'recording' && isMediaRecorder ? (
                          <>
                            <button
                              onClick={handleStopListening}
                              className="btn-stop-audio blank-btn"
                            >
                              {Right_Icon}
                            </button>
                            <button
                              onClick={handleDiscard}
                              className="btn-discard-audio blank-btn"
                            >
                              {ClOSE}
                            </button>
                          </>
                        ) : recordingStatus === 'transcribing' && isMediaRecorder ? (
                          <>
                            <button className='blank-btn  active-loader' disabled> {ANIMATED_LOADER} </button>
                            <button
                              onClick={handleDiscard}
                              className="btn-discard-audio blank-btn"
                            >
                              {ClOSE}
                            </button>
                          </>
                        ) : (
                          <button
                            onClick={handleStartListening}
                            className={`btn-start-audio blank-btn ${
                              isDisabled ? 'cursor-not-allowed' : ''
                            }`}
                            disabled={isDisabled || isVoiceAssistantOpen}
                          >
                            {DictateMICK}
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="live-visual">
                {input.trim().length > 0 ? (
                  <button
                    onClick={() => { onSendMessage(input); setTimeout(() => handleInput(), 0);  setInput('');}}
                    className={`send-msg-btn blank-btn ${
                      isDisabled || !input.trim() ? 'cursor-not-allowed' : ''
                    }`}
                    disabled={isDisabled || !input.trim()}
                  >
                    {MSG_SEND}
                  </button>
                ) : (
                  showVoiceAssistant && (
                    <VoiceAssistant
                      onError={(error) => console.error('ChatToolbar: VoiceAssistant Error:', error)}
                      voice="ash"
                      onMessage={(msg) => updateMessage(msg)}
                      onClose={(e) => onClosePopup(true)}
                      clearInput={() => setInput('')}
                      disabled={isDisabled}
                      onZakatData={onZakatData}
                      onMediaRecorderChange={handleMediaRecorderChange}
                    />
                  )
                )}
                {showDictate &&
                  isMediaRecorder &&
                  (recordingStatus === 'recording' || (isVoiceAssistantOpen && isMicOn)) && (
                    <div className="d-flex">
                      <LiveAudioVisualizer
                        mediaRecorder={isMediaRecorder}
                        width="31"
                        height={13}
                        theme="dark"
                        barColor="#fff"
                        barPlayedColor="#ffff"
                        minDecibels="-90"
                        maxDecibels="-10"
                      />
                      <p className="listen">Listening ...</p>
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatToolbar;